(function ($) {
    // Show the filters if the Filter Search button has been tapped
    $(".filter-button-container a.filter-button").on("click", function () {
        $(".filter-section-container").toggleClass("show");
    });
    $(".section-title a.close-filters-btn").on("click", function () {
        $(".filter-section-container").toggleClass("show");
        //TODO: Add an if statement to check if an filters have been activated
        $(".active-filters-container").toggleClass("show");
    });
    // If any badge is tapped, show the active filters
    /* $(".filter-section-container .filter-list-container .filter-badge").on("click", function() {
        $(".active-filters-container").addClass("show");
    }); */
})(jQuery);